/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import WarrantyInfo from 'vdp-used/components/VehicleWarranties/WarrantyInfo.jsx';
import WarrantyClass from 'vdp-used/components/VehicleWarranties/WarrantyClass.jsx';
import WarrantySupplementary from 'vdp-used/components/VehicleWarranties/WarrantySupplementary.jsx';
import 'vdp-used/components/VehicleWarranties/VehicleWarranties.scss';

const VehicleWarrantiesWrapper = ({ warranty }) => {
    return (
        <div className="showroom-vdp-used-warranties-wrapper">
            <WarrantyInfo warrantyText={warranty.supplementary.info} />
            <WarrantyClass warrantyClassText={warranty.warrantyClass.label} />
            <WarrantySupplementary supplementary={warranty.supplementary} />
            {/*
                TODO: Wait for Backend-Team to send slug for this item
                <WarrantyManufacturer
                    manufacturerList={warranty.manufacturers}
                /> */}
        </div>
    );
};

VehicleWarrantiesWrapper.propTypes = {
    warranty: PropTypes.shape({
        manufacturers: PropTypes.array.isRequired,
        supplementary: PropTypes.object.isRequired,
        warrantyClass: PropTypes.object.isRequired,
    }).isRequired,
};

VehicleWarrantiesWrapper.displayName = 'VehicleWarrantiesWrapper';

export default VehicleWarrantiesWrapper;
